module.exports = __webpack_public_path__ + "img/search1.67b9e9d9.svg";